import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import { Popover } from '@creditornot/cb-popover';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled, { useTheme } from 'styled-components';

import { CreditAcquisition } from 'apis/restaurant-api/merchant-admin/credits/types';
import { typographyCss } from 'common/typography';

import SentOfferDetails from './SentOfferDetails';
import Offer from './icons/Offer';

type SentOfferWithPopupProps = {
  timezone: string;
  sentOffer: CreditAcquisition;
};

const OfferButton = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${cbSemanticCssVars.textSecondary};
  cursor: pointer;

  svg {
    fill: ${cbSemanticCssVars.textSecondary};
    flex-shrink: 0;
    height: 20px;
    width: 20px;
  }
`;

const PopoverRoot = styled.div``;

const Row = styled.div`
  padding: 12px 16px;
`;

const Header = styled(Row)`
  ${typographyCss.Body3}
  font-weight: 600;
  border-block-end: 1px solid ${cbSemanticCssVars.borderPrimary};
`;
const Content = styled(Row)`
  ${typographyCss.Body3}
`;

const SentOfferWithPopup = ({ timezone, sentOffer }: SentOfferWithPopupProps) => {
  const { cbDirection } = useTheme();

  return (
    <Popover
      placement={cbDirection === 'rtl' ? 'bottom-end' : 'bottom-start'}
      fallbackPlacements={
        cbDirection === 'rtl'
          ? ['bottom', 'bottom-start', 'top-end', 'top', 'top-start']
          : ['bottom', 'bottom-end', 'top-start', 'top', 'top-end']
      }
      disableContentPadding
      renderArrow={false}
      showOnHover
      showOnClick
      content={
        <PopoverRoot dir={cbDirection}>
          <Header>
            <FormattedMessage id="insights.ratings-and-reviews.offers.sent-offer-title" />
          </Header>
          <Content>
            <SentOfferDetails timezone={timezone} sentOffer={sentOffer} />
          </Content>
        </PopoverRoot>
      }
    >
      <OfferButton>
        <Offer />
        <FormattedMessage id="insights.ratings-and-reviews.offers.offer-sent" />
      </OfferButton>
    </Popover>
  );
};

export default SentOfferWithPopup;
